module.exports = __webpack_public_path__ + "media/images/img_service_service_3-6f01500ab648dc7578a50d6791950a26.png";